<template>
	<div class="card mx-auto mb-6 md:mb-0 flex flex-col bg-white h-full shadow-lg rounded">
		<img class="rounded-t" :src="imagePath"></img>
		<div class="pb-4 mt-2">
			<div class="information text-blue-darkest px-4 flex flex-col">
				<h2 class="text-3xl font-bold">
					<slot name="title"></slot>
				</h2>
				<p class="description my-4 text-blue-darker leading-normal">
					<slot></slot>
				</p>
			</div>
			<div class="tags block flex ml-3">
				<slot name="tags"></slot>
			</div>
			<div class="flex justify-start mt-6">
				<div class="flex w-1/4" v-show="hasLink">
					<a v-if="external" :href="linkTo" 
					   class="card-button px-4 text-center w-full focus:outline-none focus:shadow-outline" target="_blank">View</a>
					<router-link v-else :to="linkTo" class="card-button px-4 text-center w-full focus:outline-none focus:shadow-outline">
						View
					</router-link>
				</div>
				<a :href="github" target="_blank" 
				   class="card-button w-1/4 text-center focus:outline-none focus:shadow-outline">
					Github
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	import ButtonStyles from '@/assets/scss/buttons.scss';
	export default {
		props: {
			image: {
				type: String
			},
			linkTo: {
				type: String
			},
			github: {
				type: String
			},
			external: {
				type: Boolean,
				default: false
			},
			hasLink: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {

			}
		},
		computed: {
			imagePath() {
				return `/img/${this.image}`;
			}
		}
	}
</script>

<style lang="scss" scoped>
	$dark-blue: #0F1626;

	.card {
		width: 85%;

		.tags span {
			@apply mx-1 px-3 py-1 text-sm text-white bg-gray-600 rounded-lg;
		}

		.description {
			a {
				color: $dark-blue;

				&:hover {
					text-decoration: underline;
				}
			}	
		}
	}

	@media screen and (min-width: 768px) {
		.icons-container {
			font-size: 4em;
		}
		.card {
			width: 45%;
			min-height: 505px;
		
			img {
				height: 250px; 
			}
		
			.tags {
				max-width: 75%;
			}
		}
	}
</style>
